import React from "react";
import ReactDOM from "react-dom";
import RecommendedApartments from "../elements/components/RecommendedApartments";

const rootElement = document.getElementById("recommend-travel");
const category = rootElement.getAttribute('data-category');
const meta = rootElement.getAttribute('data-meta');
const hideCategoriesButtonsData = rootElement.getAttribute('data-hide-categories-buttons');
const headerTextData = rootElement.getAttribute('data-header-text');
const cityNameData = rootElement.getAttribute('data-city-name');
const utmSourceData = rootElement.getAttribute('data-utm-source');
const additionalClassData = rootElement.getAttribute('data-additional-class');

let hideCategoriesButtons = false;
let headerText = 'recommended-trip';
let cityName = '';
let utmSource = '';
let additionalClass = '';


if (hideCategoriesButtonsData === "true") {
    hideCategoriesButtons = true;
}

if (headerTextData) {
    headerText = headerTextData;
}

if (cityNameData) {
    cityName = cityNameData;
}

if (utmSourceData) {
    utmSource = utmSourceData;
}
if (additionalClassData) {
    additionalClass = additionalClassData;
}


ReactDOM.render(
    <RecommendedApartments
        category={category}
        meta={meta}
        hideCategoriesButtons={hideCategoriesButtons}
        headerText={headerText}
        cityName={cityName}
        utmSource={utmSource}
        additionalClass={additionalClass}
    />,
    rootElement
);